import React from 'react'
import HeaderIconsGroup from '../shared/HeaderIconsGroup'
import { useTranslation } from 'react-i18next';

const PeriodExpiredCard = ({ isLoan, isIgr, IconSatis, IconExcl, IconMult, mp }) => {
    const { t } = useTranslation();

    return (
        <div className="card-early">
            <p className='title-cards-early'><b>{t('extended_report.projects_with_expired_disbursement_deadline')}</b></p>
            <HeaderIconsGroup
                showValues={Boolean(isLoan | isIgr)}
                projectsLabel={t('one_pager_report.projects')}
                items={[
                    {
                        Icon: IconSatis,
                        text: t('extended_report.within_the_deadline_for_justification'),
                        value: mp.ProjectLastDisbursementDateExpired.satisfactoryType,
                    },
                    {
                        Icon: IconExcl,
                        text: t('extended_report.with_date_last_disbursement'),
                        value: mp.ProjectLastDisbursementDateExpired.warningType,
                    },
                    {
                        Icon: IconMult,
                        text: t('extended_report.with_the_last_disbursement_date_expired'),
                        value: mp.ProjectLastDisbursementDateExpired.alertType,
                    },
                ]}
            />
        </div>
    )
}

export default PeriodExpiredCard